export default __webpack_public_path__ + "media/images/NotFound-mm-8434530dbecf1f164836e2e0eb3fe0ec.png";